import { setCookie } from 'app/shared/utils/utils';

// Save submission state if functional cookies are accepted
// Todo:- Cleanup actions, setFormSubmitted cause trouble with areCookiesAccepted === false.

import { DISMISS_POPUP, FORM_SUBMITTED } from './constants';

export const dismissPopup = (areCookiesAccepted) => {
  // If functional cookies are accepted, slide-in should be dismissed for 48 hours
  setCookie('slideIn', 'dismissed', areCookiesAccepted, 48 * 3600);
  return { type: DISMISS_POPUP };
};

export const setFormSubmitted = (areCookiesAccepted) =>
  areCookiesAccepted ? { type: FORM_SUBMITTED } : { type: DISMISS_POPUP };
